module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("profileForgot.header")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("profileForgot.enterEmail")))]), _vm._v(" "), (!_vm.token) ? _c('form', {
    staticClass: "form-inline mt-30",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'errors'
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "placeholder": _vm.$t('profileForgot.email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("profileForgot.sendReset")))])], 1) : _c('form', {
    staticClass: "form mt-30 col-md-6",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('profile.newPassword')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('profile.password')
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('profile.confirmPassword')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.repeat_password),
      expression: "user.repeat_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('profile.confirmPassword')
    },
    domProps: {
      "value": (_vm.user.repeat_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "repeat_password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), _c('alert', {
    staticClass: "col-md-12 mt-20",
    attrs: {
      "success": _vm.success,
      "error": _vm.error
    }
  })], 1), _vm._v(" "), _c('crowd-or-rais')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6be3148"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/ForgotPassword.vue
// module id = 840
// module chunks = 1